import { TextField, Button, Box } from "@mui/material";
import { ObjectIdFormFieldProps } from "../types";
import ConnectionAutocomplete from "components/form-components/connection-autocomplete";
import AddIcon from "@mui/icons-material/Add";
import React from "react";

const ObjectIdFormField = React.memo(
  ({ name, label, disabled = false, required, props, renderInputProps = {}, addButton = { show: false, props: {} } }: ObjectIdFormFieldProps) => {
    return (
      <Box
        sx={[
          (theme) => ({
            display: "flex",
            alignItems: "center",
            width: "100%",
            gap: theme.spacing(3),
          }),
        ]}
      >
        <ConnectionAutocomplete
          fullWidth
          id={name}
          disabled={disabled}
          renderInput={(params) => <TextField {...params} fullWidth label={label} required={required} name={name} {...renderInputProps} />}
          {...props}
        />
        {addButton?.show && (
          <Button
            fullWidth
            variant="contained"
            sx={{
              maxHeight: "30px",
              width: "35px",
              maxWidth: "35px",
              minWidth: "35px",
              ...(addButton.props?.sx || {}),
            }}
            {...addButton.props}
          >
            <AddIcon />
          </Button>
        )}
      </Box>
    );
  },
);

export default ObjectIdFormField;
